import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useLocaisOutletContext } from 'pages/Locais'
import { useParams } from 'react-router-dom'
import { local } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirLocal() {
    const { id } = useParams()
    const { data } = useLocaisOutletContext()
    const l = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = local.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!l) return null

    const handleSubmit = () =>
        mutateAsync(l.id, {
            onSuccess: () => {
                toast.success('Local excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'Locais'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o local {l.nomeLocal}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
